import firebase from 'firebase';
import { notification } from 'antd';

// Config DB
const database = firebase.database();
const auth = firebase.auth();


// Notification
const openNotificationWithIcon = (type, message, description) => {
    notification.config({
        duration: 3,
    });
    notification[type]({
        message: message,
        description: description,
    });
};

const getDataProgramacion = (filter) => {
    return new Promise((resolve, reject) => {
        // Dia de mañana
        const today = new Date();
        today.setDate(today.getDate() + 1);
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);

        // Date to string
        const fecha = filter ? filter : today.toString();

        // Ref DB
        database.ref().child('ProgramacionDia').orderByChild('fecha').equalTo(fecha).on('value', (snap) => {
            const data = snap.val();
            const dataValue = data && Object.entries(data);
            resolve({ ok: true, dataResult: dataValue });
        }, (e) => {
            const mensaje = 'Error al Obtener info "ProgramacionDia"';
            openNotificationWithIcon('error', mensaje, e);
            reject();
        });
    });
}

const getDataById = async (collection, key) => {
    return new Promise((resolve, reject) => {
        try {
            let data = {};
            database.ref().child(collection).child(key).once('value').then((snap) => {
                if (snap.exists()) {
                    const result = snap.val();
                    result.key = key;
                    data[key] = result;
                }
                resolve(data);
            });
        } catch (error) {
            const mensaje = 'Error al Obtener info por ID "CentroCosto"';
            openNotificationWithIcon('error', mensaje, error);
            reject();
        }
    });
}

// Eliminar todo el registro en la coleccion de "Programacion"
const deleteRecordProgramacion = (key) => {
    return new Promise((resolve, reject) => {
        database.ref().child('Programacion').child(key).set(null).then(() => {
            resolve({ ok: true });
        }, (error) => {
            const mensaje = 'Error al eliminar registro en "Programacion"';
            openNotificationWithIcon('error', mensaje, error);
            reject();
        });
    });
}

// Eliminar una sola posicion en el registro, en la coleccion de "Programacion"
const deletePositionProgramacion = (record, programaciones, fechas) => {
    const progValidar = (programaciones || []).filter((item) => {
        if (!(item == record.id)) {
            return item
        }
    });

    const fechasValidar = (fechas || []).filter((item) => {
        const fecha = new Date(record.fecha);
        const fechaItem = new Date(item);
        if (+fechaItem != +fecha) {
            return item;
        }
    });

    return new Promise((resolve, reject) => {
        database.ref().child('Programacion').child(record.idProgramacion).update({
            frecuencia: fechasValidar,
            programacionDia: progValidar,
        }).then(() => {
            resolve({ ok: true });
        }, (error) => {
            const mensaje = 'Error al eliminar registro en "Programacion"';
            openNotificationWithIcon('error', mensaje, error);
            reject();
        });
    });
}


// Vefica cuandos dias tiene una programacion (Buscandola por Key)
const verifyProgramacionById = async (keyRecord) => {

    try {
        const dataById = await getDataById('Programacion', keyRecord);
        const dataValue = dataById && Object.entries(dataById);
        let result = {};

        dataValue && (dataValue || []).map((item) => {
            // return item;
            const key = item[0];
            const { programacionDia, frecuencia } = item[1];
            const length = programacionDia.length;

            if (length == 1) {
                result = { ok: true, varios: false, keyRecordDB: key };
            } else {
                result = {
                    ok: true, varios: true, keyRecordDB: key, programacionDia: programacionDia,
                    fechas: frecuencia
                };
            }
        });

        return result;
    } catch (e) {
        const mensaje = 'Error al Obtener info "Programacion"';
        openNotificationWithIcon('error', mensaje, e);
        const result = { ok: false };
        return result;
    }
}


// Eliminar registro en la coleecion de "ProgramacionDia"
const deleteProgramacionDia = (key) => {
    return new Promise((resolve, reject) => {
        database.ref().child('ProgramacionDia').child(key).set(null).then(() => {
            openNotificationWithIcon('success', 'Eliminado', "Registro eliminado correctamente");
            resolve();
        }, (error) => {
            const mensaje = 'Error al eliminar registro en "ProgramacionDia"';
            openNotificationWithIcon('error', mensaje, error);
            reject();
        });
    });
}


// Guardar bitacora de eliminacion
const bitacoraElim = (record) => {
    return new Promise((resolve, reject) => {
        const fecha = new Date();
        const uid = auth.currentUser.uid;
        // Preparar data
        const sendData = {
            [uid]: { // Poner el UID en cabecera del JSON
                correoUser: auth.currentUser.email,
                fecha: fecha.toString(),
                dataProgramacion: { ...record },
            }
        }


        database.ref().child('logsProgramacion').push(sendData).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}


export {
    getDataProgramacion,
    getDataById,
    verifyProgramacionById,
    deleteRecordProgramacion,
    deletePositionProgramacion,
    deleteProgramacionDia,
    bitacoraElim,
    openNotificationWithIcon,
}


// WEBPACK FOOTER //
// ./src/Components/Programacion CRUD/firebaseMethods.js